// Define Http Error Classes
// http://www.w3.org/Protocols/rfc2616/rfc2616-sec10.html

export class HttpError extends Error {
    
        public statusCode : number;
        constructor(statusCode: number, name: string, message?: string) {
            super(message);
            this.name = (name) ? name : this.name;
            this.stack = (this.stack || '').split('\n').join();
            this.statusCode = statusCode;
        }
    
        public isInformational() {
            return this.statusCode >= 100 && this.statusCode < 200;
        }
    
       public isSuccessfull() {
            return this.statusCode >= 200 && this.statusCode < 300;
        };
        
        public isRedirection() {
            return this.statusCode >= 300 && this.statusCode < 400;
        };
        
        public isClient() {
            return this.statusCode >= 400 && this.statusCode < 500;
        };
        
        public isServer() {
            return this.statusCode >= 500;
        };
    }
    
    export const createErrorClass = (statusCode: number, name: string) => {
        return class extends HttpError {
            constructor(message: string) {
                super(statusCode, name, message);
            }
        };
    };
    
    export const client = {
        BadRequest: createErrorClass(400, 'Bad Request'),
        Unauthorized: createErrorClass(401, "Unauthorized"),
        Forbidden: createErrorClass(403, "Forbidden"),
        NotFound: createErrorClass(404, "Not Found"),
        Conflict: createErrorClass(409, "Conflict"),
        Gone: createErrorClass(410, "Gone"),
        TooManyRequests:createErrorClass(429, "TooManyRequests")
    };
    
    export const server = {
        ApplicationException: createErrorClass(520, "Application Exception"),
        InternalServerError: createErrorClass(500, "Internal Server Error"),
        NotImplemented: createErrorClass(501, "Not Implemented"),
        BadGateway: createErrorClass(502, "Bad Gateway"),
    };